import { initializeApp } from "firebase/app";
import {getToken, onMessage, isSupported } from "firebase/messaging";
import {notif_register} from "@/services/notifications.ts";
import CommonClass from "@/utils/common.ts";
import * as Sentry from "@sentry/react";

// TODO: Add SDKs for Firebase products that you want to use


// TODO : SECURITY AWARENES

const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUEMENT_ID,

};


if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/firebase-messaging-sw.js', { updateViaCache: 'none' })
        .then((registration) => {
            console.log('Service Worker registered with scope:', registration.scope);
        })
        .catch((error) => {
            console.error('Service Worker registration failed:', error);
        });
} else {
    console.warn('Service Workers are not supported in this browser.');
}



const app = initializeApp(firebaseConfig);
let messaging:any =  undefined

if ("serviceWorker" in navigator) {

    isSupported().then((supported) => {
        if(supported) {
            import('firebase/messaging').then((mess) => {
                messaging = mess.getMessaging(app)
            })
        }
    })
}

export const register_device = async (lang: string, push_token?: string) => {
    const userAgent = navigator.userAgent;
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let platformType = 'Other';
    let platformVersion = 'Unknown';
    let deviceType = 'desktop';
    let deviceName = 'Unknown Browser';

    let elem = document.getElementById("test_page");
    if (elem) elem.innerText = userAgent;

    const getCookie = (name: string): string | null => {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? decodeURIComponent(match[2]) : null;
    };

    const deviceUID = getCookie("ec_device_uid") || "Unknown";

    // Detect platform and device type
    if (/iPad|iPhone|iPod/.test(userAgent)) {
        platformType = 'iOS';
        deviceType = 'phone/web';

        const iosMatch = userAgent.match(/CPU (iPhone|iPad) OS (\d+_\d+)/);
        if (iosMatch) {
            platformVersion = iosMatch[2].replace('_', '.');
        }

    } else if (/Android/i.test(userAgent)) {
        platformType = 'Android';
        deviceType = /Mobile/i.test(userAgent) ? 'phone/web' : 'tablet/web';

        const androidMatch = userAgent.match(/Android (\d+(\.\d+)?)/);
        if (androidMatch) {
            platformVersion = androidMatch[1];
        }
    } else if (/Windows NT (\d+\.\d+)/.test(userAgent)) {
        platformType = 'Windows';
        platformVersion = userAgent.match(/Windows NT (\d+\.\d+)/)![1];
    } else if (/Macintosh/i.test(userAgent)) {
        platformType = 'Mac OS';
    } else if (/Linux/i.test(userAgent)) {
        platformType = 'Linux';
    }

    if (/CriOS/.test(userAgent)) {
        deviceName = "Chrome (iOS)";
    } else if (/FxiOS/.test(userAgent)) {
        deviceName = "Firefox (iOS)";
    } else if (/EdgiOS/.test(userAgent)) {
        deviceName = "Edge (iOS)";
    } else if (/Version\/[\d.]+.*Safari/.test(userAgent)) {
        deviceName = "Safari (iOS)";
    } else {
        const browserMatch = userAgent.match(/(Chrome|Firefox|Edg|Opera|Brave|MSIE|Trident)\/?(\d+(\.\d+)?)/);
        if (browserMatch) {
            deviceName = `${browserMatch[1]} ${browserMatch[2]}`;
        } else if (/Trident/.test(userAgent)) {
            deviceName = "Internet Explorer";
        }
    }

    const data = {
        platform_type: platformType,
        platform_version: platformVersion,
        device_type: deviceType,
        language: lang,
        time_zone: timeZone,
        device_uid: deviceUID,
        app_version: CommonClass.general_settings.build_version || "0.0",
        push_token: push_token ? push_token : "",
        device_name: deviceName
    };

    await notif_register(data);
};


export const requestPermission = (lang:string) => {

    if(messaging === undefined) {
        register_device(lang, "")
        return
    }

    let token = ""

    Notification.requestPermission().then((permission) => {
        if (permission === 'granted') {
            getToken(messaging, { vapidKey: import.meta.env.VITE_FIREBASE_VAPI_KEY })
                .then((currentToken) => {
                    if (currentToken) {
                        token = currentToken

                    } else {
                        console.error('No registration token available. Request permission to generate one.');
                    }
                    register_device(lang, token)
                })
                .catch((err) => {
                    Sentry.captureException(err, { tags: { section: "firebase", action: "get_push_token" } });
                });
        } else {
            console.error('Notification permission denied');
        }
    });
};




// requestPermission("");
// export const onMessageListener = () => {
//     return new Promise((resolve) => {
//         onMessage(messaging, (payload) => {
//             resolve(payload);
//             console.log('Received foreground message ', payload);
//
//             const notificationTitle = payload.data?.title || "New Notification";
//             const notificationBody = payload.data?.body || "You have a new message.";
//
//             if (payload.notification) {
//                 const notificationOptions = {
//                     body: notificationBody,
//                     icon: '/favicon.ico',
//                     data: payload.data || {}
//                 };
//
//                 new Notification(notificationTitle, notificationOptions);
//             } else {
//                 console.warn('Notification payload is missing');
//             }
//         });
//     });
// };

export const onMessageListener = () => {
    if (typeof window === "undefined" || !("Notification" in window)) {
        console.warn("Notifications are not supported in this browser.");
        return Promise.resolve(null);
    }

    if (!messaging) {
        return Promise.resolve(null);
    }

    try {
        return new Promise((resolve) => {
            onMessage(messaging, (payload) => {
                resolve(payload);
                console.log('Received foreground message ', payload);

                const notificationTitle = payload.data?.title || "New Notification";
                const notificationBody = payload.data?.body || "You have a new message.";

                if (payload.notification) {
                    new Notification(notificationTitle, {
                        body: notificationBody,
                        icon: '/favicon.ico',
                        data: payload.data || {}
                    });
                } else {
                    console.warn('Notification payload is missing');
                }
            });
        });
    } catch (error) {
        Sentry.captureException(error, { tags: { section: "firebase", action: "onMessage_listener" } });
        return Promise.resolve(null);
    }
};